/** Na Home (durante): o último aviso, o ponto de encontro ativo, e o megafone de quem administra. */
import { featureEnabled } from '@nv/core';

import { usePermissao, useTrip } from '../../trip/TripContext';
import { useAviso, useEncontro, useInvalidarEncontro } from './api';
import { AvisoAtual, BotaoAvisoRapido } from './AvisoRapido';
import { EncontroCard } from './EncontroCard';

export function EncontroNaHome() {
  const { trip, tripId } = useTrip();
  const ligado = featureEnabled(trip.features, 'ponto_de_encontro');
  const encontro = useEncontro(tripId, ligado);
  const aviso = useAviso(tripId, ligado);
  useInvalidarEncontro(tripId);
  if (!ligado) return null;
  return (
    <>
      {aviso.data?.notice && <AvisoAtual aviso={aviso.data.notice} />}
      {encontro.data?.meeting && <EncontroCard encontro={encontro.data.meeting} />}
    </>
  );
}

/** A linha "Aviso rápido" para a lista de Atalhos da Home — só quem administra. */
export function AvisoRapidoNosAtalhos() {
  const { trip } = useTrip();
  const pode = usePermissao('manage_trip_settings');
  if (!featureEnabled(trip.features, 'ponto_de_encontro') || !pode) return null;
  return <BotaoAvisoRapido comoLinha />;
}
